import createTileGraphNodeCollectionMemo from "../../lib/core/engine/TileGraphNode/createTileGraphNodeCollectionMemo"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const createSharedTileGraphNodeCollectionMemo = createSharedCachedFactory(createTileGraphNodeCollectionMemo)